exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".analytics-1{fill:#f0f9f8}.analytics-2{fill:#fff}.analytics-3{fill:#72cac2}.analytics-4{fill:#1e4e69}\n", ""]);
